import type { VoiceSnapshot } from '../voice/VoiceController';

export type Tone = 'ok' | 'busy' | 'off' | 'error';

export function describeStatus(s: VoiceSnapshot): { label: string; tone: Tone; state: string } {
  if (s.socket === 'connecting' || s.socket === 'idle') return { label: 'Connessione al server…', tone: 'busy', state: 'socket-connecting' };
  if (s.socket === 'reconnecting') return { label: 'Server non raggiungibile, riprovo…', tone: 'error', state: 'socket-reconnecting' };
  if (s.socket === 'stopped') return { label: 'Disconnesso', tone: 'off', state: 'socket-stopped' };
  switch (s.phase) {
    case 'idle':
      return s.mc === 'offline'
        ? { label: 'Minecraft offline', tone: 'off', state: 'idle' }
        : { label: 'Pronto per entrare', tone: 'off', state: 'idle' };
    case 'waiting':
      return s.mc === 'online'
        ? { label: 'In attesa della stanza…', tone: 'busy', state: 'waiting' }
        : { label: 'In attesa di Minecraft', tone: 'off', state: 'waiting' };
    case 'connecting':
      return { label: 'Connessione alla voce…', tone: 'busy', state: 'connecting' };
    case 'connected':
      return { label: 'In voce', tone: 'ok', state: 'connected' };
    case 'switching':
      return { label: 'Cambio stanza…', tone: 'busy', state: 'switching' };
    case 'reconnecting':
      return { label: 'Riconnessione…', tone: 'busy', state: 'reconnecting' };
    case 'failed':
      return { label: 'Connessione non riuscita', tone: 'error', state: 'failed' };
  }
}

export function StatusPill({ snapshot }: { snapshot: VoiceSnapshot }) {
  const d = describeStatus(snapshot);
  return (
    <div className={`status-pill tone-${d.tone}`} data-testid="connection-status" data-state={d.state} role="status" aria-live="polite">
      <span className="status-dot" aria-hidden />
      <span>{d.label}</span>
    </div>
  );
}
